import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { NotificationSnackbarProps } from "../../assets/interfaces/interfaces";
import { AlertTitle, Portal, Typography } from "@mui/material";
import { alertStyles } from "./uiConstants";

const NotificationSnackbar: React.FC<NotificationSnackbarProps> = ({
  open,
  onClose,
  title,
  message,
  severity,
  horizontal,
  showIcon = true,
}) => {
  const { bg, text } = alertStyles[severity]["standard"];
  const snackbarClass = `!bg-${bg} !text-${text}`;
  const bgVar = `var(--${bg})`;
  const textVar = `var(--${text})`;

  return (
    <Portal>
      <Snackbar
        open={open}
        autoHideDuration={5000}
        onClose={onClose}
        anchorOrigin={{ vertical: "top", horizontal }} // Position top-right
        classes={{ root: "custom-snackbar" }}
        className="w-1/2 mx-auto"
        sx={{ zIndex: 1400 }}
      >
        <Alert
          icon={showIcon ? alertStyles[severity].icon : false}
          severity={severity}
          classes={{
            root: snackbarClass,
          }}
          sx={{
            "width": "100%",
            "& .MuiAlert-icon": {
              alignSelf: "center",
            },
            "backgroundColor": `${bgVar} !important`,
            "color": `${textVar} !important`,
          }}
        >
          {title ? <AlertTitle className="font-medium text-[16px]">{title}</AlertTitle> : null}
          <Typography variant="body2/regular-400" className="text-sm">{message}</Typography>
        </Alert>
      </Snackbar>
    </Portal>
  );
};

export default NotificationSnackbar;
